export default "__VITE_ASSET__CFqZlrt0__"